export interface TrackingContextRepository {
  get: (name: string) => string;
  set: (name: string, trackingProperty: TrackingProperty) => void;
  remove: (name: string) => void;
}
